const CORNER_RADIOUS = 3;
const PARKING_OFFSET = 20;

const getIsTopToBottom = (subjectPoint, objectPoint) =>
  subjectPoint.x <= objectPoint.x ? subjectPoint.y <= objectPoint.y : subjectPoint.y >= objectPoint.y;
const getIsRightPointEndOnRight = (subjectPoint, objectPoint, isSubjectStart, isObjectStart) =>
  subjectPoint.x <= objectPoint.x ? !isObjectStart : !isSubjectStart;

const getTotalWidth = (subjectPoint, objectPoint, padding = 0) =>
  Math.abs(subjectPoint.x - objectPoint.x) + padding * 2;
const getTotalHeight = (subjectPoint, objectPoint, padding = 0) =>
  Math.abs(subjectPoint.y - objectPoint.y) + padding * 2 + (subjectPoint.y === objectPoint.y ? PARKING_OFFSET : 0);

const getNormalPath = (startX, startY, endX, endY, isTopToBottom) => {
  return (
    `M${startX} ${startY} ` +
    `V ${endY - CORNER_RADIOUS * (isTopToBottom ? 1 : -1)} ` +
    `Q ${startX} ${endY} ${startX + CORNER_RADIOUS} ${endY} ` +
    `H ${endX}`
  );
};

const getParkingPath = (startX, startY, endX, endY, isTopToBottom) => {
  const verticalSign = isTopToBottom ? 1 : -1;
  const parkingY = endY - PARKING_OFFSET * verticalSign;
  return (
    `M${startX} ${startY} ` +
    `V ${parkingY - CORNER_RADIOUS * verticalSign} ` +
    `Q ${startX} ${parkingY} ${startX + CORNER_RADIOUS} ${parkingY} ` +
    `H ${endX - CORNER_RADIOUS} ` +
    `Q ${endX} ${parkingY} ${endX} ${parkingY + CORNER_RADIOUS * verticalSign} ` +
    `V ${endY}`
  );
};

const getHorizontalPath = (startX, endX, theY, padding) => {
  const parkingY = theY + PARKING_OFFSET - padding;
  return (
    `M${startX} ${theY} ` +
    `V ${parkingY - CORNER_RADIOUS} ` +
    `Q ${startX} ${parkingY} ${startX + CORNER_RADIOUS} ${parkingY} ` +
    `H ${endX - CORNER_RADIOUS} ` +
    `Q ${endX} ${parkingY} ${endX} ${parkingY - CORNER_RADIOUS} ` +
    `V ${theY}`
  );
};

const getDependencyPath = (subjectPoint, objectPoint, isSubjectLeft, isObjectLeft, isAbsolutePosition, padding = 0) => {
  const isTopToBottom = getIsTopToBottom(subjectPoint, objectPoint);
  const isRightPointEndOnRight = getIsRightPointEndOnRight(subjectPoint, objectPoint, isSubjectLeft, isObjectLeft);
  const width = getTotalWidth(subjectPoint, objectPoint, padding);
  const height = getTotalHeight(subjectPoint, objectPoint, padding);
  const absoluteX = isAbsolutePosition ? Math.min(subjectPoint.x, objectPoint.x) : 0;
  const absoluteY = isAbsolutePosition ? Math.min(subjectPoint.y, objectPoint.y) : 0;
  const startX = padding + absoluteX;
  const startY = (isTopToBottom ? padding : height - padding) + absoluteY;
  const endX = width - padding + absoluteX;
  const endY = (isTopToBottom ? height - padding : padding) + absoluteY;
  const pathDes =
    subjectPoint.y === objectPoint.y
      ? getHorizontalPath(startX, endX, startY, padding)
      : isRightPointEndOnRight
        ? getParkingPath(startX, startY, endX, endY, isTopToBottom)
        : getNormalPath(startX, startY, endX, endY, isTopToBottom);
  return pathDes;
};

const shouldShowDependencyLine = (depPos, depOrConstraint) => {
  let result = false;
  if (depPos && depOrConstraint && depPos.subjectPoint && depPos.objectPoint) {
    const dx = Math.abs(depPos.subjectPoint.x - depPos.objectPoint.x);
    const dy = Math.abs(depPos.subjectPoint.y - depPos.objectPoint.y);
    result = !(dx > 10000 || dy > 10000);
  }
  return result;
};

export default {
  getIsTopToBottom,
  getIsRightPointEndOnRight,
  getTotalWidth,
  getTotalHeight,
  getDependencyPath,
  shouldShowDependencyLine
};
